import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";

export interface SearchBoxOptions {
  showFilterBtn?: boolean;
  triggerSearchOnBlur?: boolean;
  triggerSearchOnChange?: boolean;
  required?: boolean;
}

@Component({
  selector: "search-box",
  templateUrl: "./search-box.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchBox implements OnInit {
  @Input() options: SearchBoxOptions = {};
  @Input() searchCriteria: string = "";
  @Output() searchCriteriaChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() showFilters: EventEmitter<Event> = new EventEmitter<Event>();
  @Input() placeHolder: string = "Search ...";
  @Input() buttonText: string = "Search";
  @ViewChild("inputbox") inputBoxRef: ElementRef;

  lastSearchCriteria: string;

  ngOnInit() {
    // Observable.fromEvent(this.inputBoxRef.nativeElement, 'keydown')
    //     .debounceTime(1000)
    //     .subscribe((e: Event) => {
    //         this.doSearch((<any>e.target).value, false, e);
    //     });
  }

  doSearch(criteria: string, force: boolean, event: Event) {
    if (event) {
      event.preventDefault();
    }

    let currentValue = criteria ? criteria : "";
    let lastValue = this.lastSearchCriteria ? this.lastSearchCriteria : "";

    if (!force && currentValue === lastValue) return; //prevent multiple search commands using same criteria

    this.lastSearchCriteria = currentValue;

    this.searchCriteriaChanged.emit(this.lastSearchCriteria);
  }
  change(criteria: string, event: Event) {
    if (this.options.triggerSearchOnChange) {
      this.doSearch(criteria, true, event);
    }
  }
  showFiltersDlg(event: Event) {
    this.showFilters.emit(event);
  }

  focus() {
    this.inputBoxRef.nativeElement.focus();
  }
}
